import styled from "styled-components";

import { smallScreen } from "src/shared/constants/screenSizes";

export const Section = styled.section`
  padding: 80px 48px 56px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 32px 24px 56px;
  }
`;
